export enum AppTypeTranslationEnum {
    TermsShort = 'TermsShort',
    TermsLong = 'TermsLong',
    TermsAgree = 'TermsAgree',
    MedicalCareType = 'MedicalCareType',
    DescriptionOfOccurrence = 'DescriptionOfOccurrence',
    IAgreeTermsPart1 = 'IAgreeTermsPart1',
    IAgreeTermsPart2 = 'IAgreeTermsPart2',
    IAgreeTermsPart3 = 'IAgreeTermsPart3',
    VisitDate = 'VisitDate',
    MedicalContactCenter = 'MedicalContactCenter',
}
